import { CSSProperties } from 'react';
import Image from 'next/image';

interface Props {
	/**
	 * Should only be used by `PnlModalAssetPreloader`.
	 */
	style?: CSSProperties;
}

export default function PnlModalCardPreviewDriftLogos({ style }: Props) {
	return (
		<Image
			src="/assets/icons/text-logo-dark-theme-2.svg"
			style={style}
			alt=""
			fill
		/>
	);
}
